import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import HomePageEditor from '../components/HomePageEditor';
import CollectionsManager from '../components/CollectionsManager';
import ProductsManager from '../components/ProductsManager';
import ServicesManager from '../components/ServicesManager';
import SpecialtiesManager from '../components/SpecialtiesManager';
import BusinessInfoEditor from '../components/BusinessInfoEditor';
import InquiriesManager from '../components/InquiriesManager';
import SiteSettingsEditor from '../components/SiteSettingsEditor';
import AdminsManager from '../components/AdminsManager';
import StatsManager from '../components/StatsManager';
import { API_BASE_URL } from '../config';
import './AdminDashboard.css';

const SECTIONS = {
  inquiries: InquiriesManager,
  services: ServicesManager,
  specialties: SpecialtiesManager,
  businessinfo: BusinessInfoEditor,
  homepage: HomePageEditor,
  collections: CollectionsManager,
  products: ProductsManager,
  sitesettings: SiteSettingsEditor,
  admins: AdminsManager,
  stats: StatsManager,
};

export default function AdminDashboard() {
  const { user, authenticatedFetch } = useAuth();
  const [active, setActive] = useState('dashboard');
  const [stats, setStats] = useState({ services: 0, newInquiries: 0 });

  useEffect(() => {
    if (active !== 'dashboard') return;
    (async () => {
      try {
        const [svcRes, inqRes] = await Promise.all([
          authenticatedFetch(`${API_BASE_URL}/api/services/admin/all`),
          authenticatedFetch(`${API_BASE_URL}/api/inquiries?status=NEW`),
        ]);
        const services = svcRes.ok ? await svcRes.json() : [];
        const newInquiries = inqRes.ok ? await inqRes.json() : [];
        setStats({
          services: services.filter((s) => s.published).length,
          newInquiries: newInquiries.length,
        });
      } catch (_) { /* ignore */ }
    })();
  }, [active, authenticatedFetch]);

  if (active !== 'dashboard') {
    const Comp = SECTIONS[active];
    return (
      <div className="admin-dashboard">
        <div className="admin-header">
          <button className="back-button" onClick={() => setActive('dashboard')}>← Back to Dashboard</button>
        </div>
        {Comp ? <Comp /> : null}
      </div>
    );
  }

  const card = (key, title, desc, badge) => (
    <div className="admin-card" key={key}>
      {badge != null && badge > 0 && <div className="admin-card-badge">{badge}</div>}
      <h3>{title}</h3>
      <p>{desc}</p>
      <button className="card-button" onClick={() => setActive(key)}>Open</button>
    </div>
  );

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <p>Welcome back, {user?.name || user?.email}</p>
      </div>

      <div className="admin-grid">
        {card('inquiries',   'Inquiries',     'Review and respond to contact-form submissions', stats.newInquiries)}
        {card('services',    'Services',      'Manage services, pricing, and add-ons')}
        {card('specialties', 'Specialties',   'Manage areas of focus shown on the public Specialties page')}
        {card('businessinfo','Business Info', 'Bio, location, hours, contact details')}
        {card('homepage',    'Home Page',     'Edit hero copy and home sections')}
        {card('sitesettings','Site Settings', 'Coming Soon mode and active theme')}
        {card('collections', 'Collections',   'Manage craft collections')}
        {card('products',    'Products',      'Manage craft products')}
        {card('admins',      'Admins',        'Change your password and manage admin users')}
        {card('stats',       'Stats',         'Page views, visitors, referrers, and inquiry funnel')}
      </div>

      <div className="admin-stats">
        <div className="stat-card"><h4>Published Services</h4><p className="stat-number">{stats.services}</p></div>
        <div className="stat-card"><h4>New Inquiries</h4><p className="stat-number">{stats.newInquiries}</p></div>
      </div>
    </div>
  );
}
